import authAxios, { authHeader } from "../data";

const create = async (batchId: string, request: any) => {
  const result = await authAxios.post(
    `/api/batches/${batchId}/autocharges/create`,
    request,
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const AutoChargesService = {
  create,
};

export default AutoChargesService;
